<template>
	<div id="body" v-if="show">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated" ata-wow-delay="0.4s">
							<h1>{{home}}</h1>
						</div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated" ata-wow-delay="0.4s">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/about_us">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<!-- About Section -->
		<section class="about-section">
			<div class="container">
				<div class="row">
					<div class="col-md-12 col-sm-12 col-xs-12">
						<div class="col-md-6 col-sm-6 col-xs-12">
							<div class="about-img-area wow fadeInDown animated" data-wow-delay="0.4s">
								<img loading="lazy" class="alignnone  wp-image-37" :src="baseUrl + article.cover_image" alt="" width="590" height="244" sizes="(max-width: 590px) 100vw, 590px" />
							</div>
						</div>
						<div class="col-md-6 col-sm-6 col-xs-12 wow fadeInDown animated" data-wow-delay="0.4s">
							<h2><strong>{{article.title}}</strong></h2>
							<div v-html="article.content"></div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Portfolio Section -->
		<section class="portfolio-section">
			<div class="container">
				<!-- Section Title -->
				<div class="row">
					<div class="col-md-12">
						<div class="section-header">
							<h1 class="widget-title wow fadeInUp" data-wow-duration="500ms" data-wow-delay="0ms">{{content[2].category.title}}</h1>
							<div class="widget-separator"><span></span></div>
							<p class="wow fadeInDown">{{content[2].category.desc_text}}</p>
						</div>
					</div>
				</div>
				<!-- /Section Title -->
				<!-- Item Scroll -->
				<div class="row">
					<div id="portfolio-carousel">
						<div class="col-md-4 col-sm-6 col-xs-12 port1" v-for="item in content[2].list">
							<article class="post">
								<figure class="post-thumbnail">
									<img style="width: 328px;height: 338px;" class="img-responsive" alt="img" :src="baseUrl + item.cover_image">
								</figure>
								<header class="entry-header">
									<h4 class="entry-title"><a href="javascript:;">{{item.title}}</a></h4>
								</header>
								<div class="entry-content">
									<p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{item.content}}</p>
								</div>
							</article>
						</div>
					</div>
				</div>
				<!-- /Item Scroll -->

			</div>
		</section>
		<!-- /Portfolio Section -->

		<!-- /About Section -->
		<div class="clearfix"></div>
		<section class="testimonial-section" style="background-image:url(/static/image/国家基因库.png); background-repeat: no-repeat; background-position: top left;">
			<div class="overlay" style="background-color:rgba(0,0,0,0.6)">
				<div class="container">
					<!-- Section Title -->
					<div class="row">
						<div class="col-md-12">
							<div class="section-header">
								<h1 class="white wow fadeInUp animated" data-wow-delay="0ms" data-wow-duration="500ms">{{content[3].category.title}}</h1>
								<div class="widget-separator"><span></span></div>
								<p class="white wow fadeInDown animated">{{content[3].category.desc_text}} </p>
							</div>
						</div>
					</div>
					<!-- /Section Title -->
					<!-- Testimonial -->
					<div class="row">
						<div class="item">
							<div class="media testmonial-area">
								<div class="author-box">
									<img :src="baseUrl + content[3].list[0].cover_image" class="img-circle" alt="img">
								</div>
								<div class="media-body">
									<div class="description-box">
										<div class="author-description">
											<p>{{content[3].list[0].content}}</p>
										</div>
									</div>
									<h4>{{content[3].list[0].title}}</h4>
								</div>

							</div>
						</div>
					</div>
					<!-- /Testimonial -->

				</div>
			</div>
		</section>

	</div>
</template>

<script>
	import { getIndex, getArticle } from '../api/api';
	export default {
		data() {
			return {
				show: false,
				baseUrl: 'http://admin.brlsea.org',
				article: '',
				content: '',
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onGetData() {
				let that = this;
				getArticle({
					lang: this.lang,
					category: 1,
				}).then(res => {
					if(res.code == 1) {
						that.article = res.data[0];
					}
				});
				getIndex({ //首页数据
					lang: this.lang
				}).then(res => {
					if(res.code == 1) {
						that.content = res.data;
						that.show = true;
					}
				});
			}
		},
		created() {
			this.onGetData();
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">

</style>


// WEBPACK FOOTER //
// src/components/about_us.vue